<template>
    <div>
        <Navbar />
        <main>
            <slot />
        </main>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue';
import Footer from '../components/Footer.vue';

export default {
    name: 'MainLayout',
    components: {
        Navbar,
        Footer,
    },
};
</script>

<style scoped>
main {
    min-height: 60vh;
}
</style>